import {gql} from 'apollo-angular';

export const uploadFile = gql`
    mutation uploadFile($file: Upload!, $metadata: FileMetadataInputObject!){
      response: uploadFile(file: $file, metadata: $metadata) {
        _id
      }
    }`
